import { Action, CustomTagType, DialogPosition, DockType, OperationType, Position, WindowType } from "puzzle";
import SupplierWordCount from "../../components/SupplierView/TaskList/Actions/WordCount/SupplierWordCount";


export const openSupplierWordCount: Action = [{
  persistent: ['submissionData'],
  type: OperationType.addPersistentData
}, {
  data: {
    asSubName: true,
  },
  type: OperationType.data
}, {
  data: {
    method: 'post',
    template: {
      url: `/jobPhases/wordCount`,
      bind: {
        params: '{wordCountParams}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'getDownloadAnalysisPolicy',
  type: OperationType.action
}, {
  title: 'wordCount.title',
  children: [{
    render: SupplierWordCount,
    propArgs: ['submissionData']
  }],
  className: 'xl with-custom-header supplier-word-count',
  items: [
    {
      btnName: 'submissionName',
      btnConfig: {
        args: [
          'submissionId',
          'submissionName',
          'asSubName'
        ],
        customTagType: CustomTagType.label,
        dock: DockType.top,
        pos: Position.end
      },
      operations: []
    }, {
      btnName: 'wordCount.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      },
      operations: [{
        persistent: ['submissionData'],
        type: OperationType.removePersistentData
      }
      ]
    },
    {
      operations: [{
        moduleName: 'SupplierWordCount',
        name: 'getSubmissionData',
        mappingName: 'submissionData',
        type: OperationType.addOperationData
      }, {
        data: {
          template: {
            params: {
              downloadType: "tmStatistics",
            }
          }
        },
        name: 'downloadFiles',
        type: OperationType.action
      }],
      btnName: 'wordCount.download',
      btnConfig: {
        template: {
          bind: {
            hidden: '!{hasDownloadAnalysis}'
          }
        },
        themeColor: 'primary',
        pos: Position.end
      }
    }, {
      btnName: 'ESCAPE',
      close: false,
      operations: [{
        index: DialogPosition.last,
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }, {
        persistent: ['submissionData'],
        type: OperationType.removePersistentData
      }]
    }
  ],
  type: OperationType.dialog
}, {
  moduleName: 'SupplierWordCount',
  args: ['responseData'],
  name: 'setData'
}];
